import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { LookupDetail } from "../models/lookup-detail.model";

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.apiUrl = baseUrl + 'api/';
  }

  get(params: HttpParams, lookupName: string) {
    const url = this.apiUrl + lookupName;
    return this.httpClient.get<LookupDetail[]>(url, { params: params, observe: 'response' });
  }

  getDetail(id: number, lookupName: string) {
    const url = this.apiUrl + lookupName + '/' + String(id);
    return this.httpClient.get<LookupDetail>(url);
  }

  create(data: LookupDetail, lookupName: string) {
    const url = this.apiUrl + lookupName;
    return this.httpClient.post(url, JSON.stringify(data), { headers: this.headers });
  }

  update(data: LookupDetail, lookupName: string) {
    const url = this.apiUrl + lookupName;
    return this.httpClient.put(url, JSON.stringify(data), { headers: this.headers });
  }
}
